import { RecentlyWatched as RecentlyWatchedScreen } from "@/app/modules/Playlists";

export const RecentlyWatched = () => {
  return <RecentlyWatchedScreen />;
};
